module.exports = __webpack_public_path__ + "static/media/logo.491b102a.png";